import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { UserTypes } from '$core/models/user';
import {
  AuthParamsValues,
  AUTH_TYPE_KEY,
  USER_TYPE_KEY,
} from '$core/models/auth-modals-query-params';
import { AuthModalComponent } from '$core/models/auth-modal-component';

@Injectable({
  providedIn: 'root',
})
export class AuthModalsService {
  constructor(
    private modalService: BsModalService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  private _setQueryParam(params: Params): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  public setUserTypeQueryParam(userType: UserTypes | null): void {
    let type: UserTypes;

    if (userType === UserTypes.Individual) {
      type = UserTypes.Individual;
    } else {
      type = UserTypes.Legal;
    }

    const params: Params = {
      [USER_TYPE_KEY]: type,
    };

    this._setQueryParam(params);
  }

  public setQueryParam(
    authType: AuthParamsValues | null,
    userType: UserTypes | null
  ): void {
    const params: Params = {
      [AUTH_TYPE_KEY]: authType,
      [USER_TYPE_KEY]: userType,
    };

    this._setQueryParam(params);
  }

  public show(
    modalComponent: AuthModalComponent,
    userType: UserTypes,
    authType: AuthParamsValues,
    state: Record<string, any> = {}
  ): void {
    const initialState = {
      ...state,
      activeType: userType,
    };

    this.modalService.show(modalComponent as any, {
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
      initialState,
    });
    this.setQueryParam(authType, userType);
  }

  public hide(): void {
    this.clearQueryParam();
  }

  public clearQueryParam(): void {
    this.setQueryParam(null, null);
  }
}
